import type { RoutablePageConfig } from '@kizenapps/engine';
import {
  CUSTOM_CODE_PLUGIN_PREFIX,
  isCustomCodeContent,
  toEngineViewConfigs,
} from 'components/DashboardGrid/hooks/customCodeBlock';
import type { RegisterInlinePages } from 'ts-components/Plugins/inlinePages';

export const blockViewsKey = (content: unknown, dashletId: string): string =>
  JSON.stringify(
    isCustomCodeContent(content) ? toEngineViewConfigs(content, dashletId) : []
  );

export const registerBlockViews = (
  register: RegisterInlinePages,
  viewsKey: string,
  dashletId: string
): (() => void) | undefined => {
  const pages = JSON.parse(viewsKey) as RoutablePageConfig[];
  if (!dashletId || !pages.length) {
    return undefined;
  }
  return register(`${CUSTOM_CODE_PLUGIN_PREFIX}${dashletId}`, pages);
};
